import {UIAjaxWrapper} from '../../../../../../shared/scripts/network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../../../../../../shared/scripts/network/UIAPIEndpoints'
import {UIProfileSettingsController} from '../../../../../../shared/scripts/profile/UIProfileSettingsController'
import {ViewPopup} from '../../../../../../shared/scripts/ui_popup/ViewPopup'
import {UIMDeviceInfoPopup} from '../../../../ui_popup/UIMDeviceInfoPopup'
import {StorageWrapper} from '../../../../../../shared/scripts/StorageWrapper'
import {getHomepageUrl, navigateToPage} from '../../../../../../shared/scripts/ui_utils/ClientUtils'
import {ViewPopupEditProfile} from '../../../../../../shared/scripts/ui_popup/ViewPopupEditProfile'
import {UIMProfileUsernameController} from '../UIMProfileUsernameController'
import {PlayerColor} from '@colonist/game-states'
import {ProfileEditAjaxEndPoints} from '../../../../../../shared/scripts/profile/ProfileEditAjaxEndPoints'

export class UIMProfileSettingsController extends UIProfileSettingsController {
    private readonly logoutButton: HTMLDivElement
    private readonly editProfileButton: HTMLButtonElement

    constructor() {
        super()
        this.logoutButton = document.getElementById('m-logout-button') as HTMLDivElement
        this.logoutButton.onclick = () => UIMProfileSettingsController.handleLogout()

        this.editProfileButton = document.getElementById('m-edit-profile') as HTMLButtonElement
        this.editProfileButton.onclick = () => new ViewPopupEditProfile({
            usernameController: UIMProfileUsernameController,
            selectColorAction: async(color: PlayerColor) => await ProfileEditAjaxEndPoints.updatePreferredColor(color),
        })

        const deviceInfoButton = document.getElementById('m-debug-info') as HTMLButtonElement
        deviceInfoButton.onclick = () => new UIMDeviceInfoPopup().show()
    }

    private static handleLogout() {
        const popup = new ViewPopup({key: 'strings:homePage.header.logoutPopup.title'},
            {key: 'strings:homePage.header.logoutPopup.body'},
            async() => {
                const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.logout(), undefined, undefined)
                if(response == undefined) return
                StorageWrapper.setUserBypassedLogin(false)
                StorageWrapper.clearUserState()
                navigateToPage(getHomepageUrl())
            },
            () => undefined, false)
        popup.show()
    }
}
